import useMediaQuery from "hooks/use-media-query";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "store/selector";
import { createCount } from "store/services";
import { actions } from "store/slice";
import { getItem, setItem } from "utils/local-storage";
import DesktopHeader from "./desktop-header";
import MobileHeader from "./mobile-header";

// ---------- localStorage helpers for per-user plan persistence ----------
const PLAN_LS_PREFIX = "kw_plan_";

/** Returns the localStorage key for a given userId's plan */
const planKey = (userId) => `${PLAN_LS_PREFIX}${userId}`;

/** Read the persisted plan for a userId from localStorage */
export const getPersistedPlan = (userId) => {
  if (!userId) return null;
  return getItem(planKey(userId)); // returns { plan, planExpiresAt } or null
};

/**
 * Persist plan info for a userId into localStorage.
 * Should only be called at login time (login.js).
 * Plan changes very infrequently so there is no need to re-fetch it on
 * every page navigation — localStorage is the source of truth between logins.
 */
export const persistPlan = (userId, plan, planExpiresAt) => {
  if (!userId) return;
  setItem(planKey(userId), { plan, planExpiresAt });
};
// -----------------------------------------------------------------------

const Header = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(getUser);
  const { isDesktop } = useMediaQuery();

  // Fetch visit counter (intentional per-session call)
  useEffect(() => {
    const storedToken = getItem("the_main_app");
    if (!storedToken) return;

    createCount(storedToken)
      .then((res) => {
        if (res?.data?.success) {
          dispatch(actions.setCount(res?.data?.count));
        }
      })
      .catch((err) => console.error(err));
  }, [dispatch, token]);

  // Restore auth state and plan from localStorage on every mount/token change.
  // No fetchPlanInfo API call — plan is written once at login (persistPlan in
  // login.js) and always keyed to the specific userId, so it's always correct.
  useEffect(() => {
    dispatch(actions.setToken(getItem("the_main_app")));

    const storedCurrentUser = getItem("current_user");
    if (storedCurrentUser) {
      const userId = storedCurrentUser.userId;

      // Always prefer the userId-keyed persisted plan over whatever was in
      // current_user (which may have been saved before plan field existed).
      const persisted = getPersistedPlan(userId);
      const mergedUser = {
        ...storedCurrentUser,
        ...(persisted?.plan
          ? { plan: persisted.plan, planExpiresAt: persisted.planExpiresAt }
          : {}),
      };

      dispatch(actions.setLoginSuccess(mergedUser));
    }

    const url = window.location.href;
    url.includes("profile") && dispatch(actions.setEditProfile(true));
    url.includes("profileedit") && dispatch(actions.setEditProfile(false));
  }, [dispatch, token]);

  return (
    <div className="lime-header" style={{ backgroundColor: "#f7f8fa" }}>
      {isDesktop ? <DesktopHeader /> : <MobileHeader />}
    </div>
  );
};

export default Header;
